import Vue from 'vue';
import VueRouter, {RouterOptions} from 'vue-router';
import ExamStart from '@/main/frontend/pages/exam_start/ExamStart.vue';
import CodingTest from '@/main/frontend/pages/coding_test/CodingTest.vue';
import ThoughtInput from '@/main/frontend/pages/thought_input/ThoughtInput.vue';
import ExamEnd from '@/main/frontend/pages/exam_end/ExamEnd.vue';
import AdminLogin from '@/main/frontend/pages/admin_login/AdminLogin.vue';
import NewLoginInfo from '@/main/frontend/pages/new_login_info/NewLoginInfo.vue';
import LoginInfo from '@/main/frontend/pages/login_info/LoginInfo.vue';
import ExamResult from '@/main/frontend/pages/exam_result/ExamResult.vue';
import ScoringInput from '@/main/frontend/pages/scoring_input/ScoringInput.vue';
import NotFound from '@/main/frontend/components/NotFound.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
  },
  {
    path: '/exam/start',
    name: 'ExamStart',
    component: ExamStart,
    meta: { title: '試験開始' },
  },
  {
    path: '/exam/editor',
    name: 'CodingTest',
    component: CodingTest,
    meta: { title: 'コーディング試験' },
  },
  {
    path: '/exam/thought_input',
    name: 'ThoughtInput',
    component: ThoughtInput,
    meta: { title: '感想入力' },
  },
  {
    path: '/exam/end',
    name: 'ExamEnd',
    component: ExamEnd,
    meta: { title: '試験終了' },
  },
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: AdminLogin,
    meta: { title: 'ログイン' },
  },
  {
    path: '/admin',
    name: 'ExamResult',
    component: ExamResult,
    meta: { title: '試験結果一覧' },
  },
  {
    path: '/admin/new_login_info',
    name: 'NewLoginInfo',
    component: NewLoginInfo,
    meta: { title: 'ログイン情報発行' },
  },
  {
    path: '/admin/login_info',
    name: 'LoginInfo',
    component: LoginInfo,
    meta: { title: '発行済みログイン情報' },
  },
  {
    path: '/admin/scoring_input',
    name: 'ScoringInput',
    component: ScoringInput,
    meta: { title: '採点入力' },
  },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
  } as RouterOptions);

export default router;
